import { Stack, styled, css, Box, Typography } from '@mui/material';

export const ReplyPreviewContainer = styled(Stack)(
  ({ theme }) => css`
    background: ${theme.palette.common.white};
    padding: 0.5rem 0.8rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  `
);

export const AccentBar = styled(Box)(
  ({ theme }) => css`
    width: 3px;
    align-self: stretch;
    background-color: ${theme.palette.primary.main};
    border-radius: 2px;
  `
);

export const PreviewContent = styled(Stack)(
  () => css`
    flex: 1;
    min-width: 0;
    overflow: hidden;
  `
);

export const SenderName = styled(Typography)(
  ({ theme }) => css`
    font-weight: 600;
    font-size: 1rem;
    color: ${theme.palette.primary.main};
  `
);

export const PreviewText = styled(Typography)(
  ({ theme }) => css`
    font-size: 1rem;
    color: ${theme.palette.neutral.var60};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
);
